import React, { useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const ChangeFbTokenButton = () => {
  const [open, setOpen] = useState(false);

  const [shortToken, setShortToken] = useState("");
  const [longUserToken, setLongUserToken] = useState("");
  const [pageToken, setPageToken] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleClose = () => {
    setOpen(false);
    setShortToken("");
    setLongUserToken("");
    setPageToken("");
    setError("");
    setSuccessMsg("");
    setLoading(false);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError("");
      setSuccessMsg("");
      setLongUserToken("");
      setPageToken("");

      if (!shortToken.trim()) {
        setError("Veuillez coller un short token.");
        return;
      }

      const res = await axios.post(
        `${API_URL}/api/fbposts/changetoken`,
        { shortToken: shortToken.trim() },
        { headers: { "Content-Type": "application/json" } }
      );

      setLongUserToken(res.data.longUserToken || "");
      setPageToken(res.data.pageToken || "");
      setSuccessMsg("Token échangé avec succès.");
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message ||
          "Erreur lors de l’échange du token. Vérifiez le token et réessayez."
      );
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async (value) => {
    try {
      await navigator.clipboard.writeText(value);
      setSuccessMsg("Copié dans le presse-papiers.");
      setTimeout(() => setSuccessMsg(""), 1500);
    } catch {
      setError("Impossible de copier automatiquement. Copiez manuellement.");
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="px-4 py-2 bg-primary-6000 text-white rounded hover:bg-primary-700 transition"
      >
        Change token
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* overlay */}
          <div
            className="absolute inset-0 bg-black/50"
            onClick={handleClose}
          />

          {/* modal */}
          <div className="relative z-10 w-[95%] max-w-2xl rounded-lg bg-white p-6 shadow-xl">
            <div className="flex items-start justify-between gap-4">
              <h3 className="text-xl font-bold">Changer le token Facebook</h3>
              <button
                onClick={handleClose}
                className="px-3 py-1 rounded border hover:bg-gray-50"
                aria-label="Fermer"
              >
                ✕
              </button>
            </div>

            <p className="mt-2 text-sm text-gray-600">
              Collez un <b>short-lived user token</b> (obtenu via Graph API
              Explorer). Le backend va l’échanger contre un token long-lived.
            </p>

            <div className="mt-4">
              <label className="block text-sm font-semibold mb-2">
                Short token
              </label>
              <textarea
                value={shortToken}
                onChange={(e) => setShortToken(e.target.value)}
                rows={4}
                className="w-full border rounded p-3 font-mono text-sm"
                placeholder="EAABsbCS1..."
              />
              <div className="mt-3 flex gap-3">
                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  className="px-5 py-2 bg-primary-6000 text-white rounded hover:bg-primary-700 transition disabled:opacity-60"
                >
                  {loading ? "Échange..." : "Envoyer au backend"}
                </button>

                <button
                  onClick={handleClose}
                  className="px-5 py-2 border rounded hover:bg-gray-50"
                  disabled={loading}
                >
                  Annuler
                </button>
              </div>
            </div>

            {(error || successMsg) && (
              <div className="mt-4">
                {error && (
                  <p className="text-red-600 font-semibold">{error}</p>
                )}
                {successMsg && (
                  <p className="text-green-700 font-semibold">{successMsg}</p>
                )}
              </div>
            )}

            {(longUserToken || pageToken) && (
              <div className="mt-6 space-y-4">
                {longUserToken && (
                  <div>
                    <div className="flex items-center justify-between gap-2">
                      <h4 className="font-bold">Long-lived User Token</h4>
                      <button
                        onClick={() => copyToClipboard(longUserToken)}
                        className="px-3 py-1 border rounded hover:bg-gray-50 text-sm"
                      >
                        Copier
                      </button>
                    </div>
                    <textarea
                      readOnly
                      value={longUserToken}
                      rows={3}
                      className="w-full border rounded p-3 mt-2 font-mono text-sm bg-gray-50"
                    />
                  </div>
                )}

                {pageToken && (
                  <div>
                    <div className="flex items-center justify-between gap-2">
                      <h4 className="font-bold">Page Access Token</h4>
                      <button
                        onClick={() => copyToClipboard(pageToken)}
                        className="px-3 py-1 border rounded hover:bg-gray-50 text-sm"
                      >
                        Copier
                      </button>
                    </div>
                    <textarea
                      readOnly
                      value={pageToken}
                      rows={3}
                      className="w-full border rounded p-3 mt-2 font-mono text-sm bg-gray-50"
                    />
                    <p className="text-xs text-gray-600 mt-2">
                      Conseil : utilisez plutôt le <b>Page Access Token</b> dans
                      votre backend pour lire les posts de la page.
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ChangeFbTokenButton;
